import React from "react";

import { Stack, Typography } from "@mui/material";
import parse from "html-react-parser";
import { Trans } from "react-i18next";

import { Heading1 } from "../../atoms/Typography/Heading/Heading";

const Content = ({ index, title, description }) => {
  return (
    <div>
      <div style={{ marginBottom: "16px" }}>
        <Heading1 text={`${index}.- ${title}`} />
      </div>
      <Typography style={{ textAlign: "justify", marginBottom: "40px" }}>
        {parse(description)}
      </Typography>
    </div>
  );
};

export default Content;
